export class ProxyFetcher {
  constructor({httpFetcher, authenticationFetcher, fakeFetcher}) {
    this._httpFetcher = httpFetcher
    this._authenticationFetcher = authenticationFetcher
    this._fakeFetcher = fakeFetcher
  }

  create({for: url, fetcherOptions} = {}) {
    const {alwaysSendAuthorizationToken = false, isUserLogged = false} = fetcherOptions || {}

    if (url.match(/\/v2\/users\/[0-9]+\/alerts\/[a-z0-9-]+$/)) return this._httpFetcher
    if (
      url.match(/\/v\d*\/transactions/) ||
      url.match(/\/publisher\/users/) ||
      url.match(/\/users\/\d*\/classifieds\/\d*\/instant-offers\d*/) ||
      url.match(/\/api_gateway_mc_proxy\/api\/hal\/\d*\/conversations\d*/) ||
      url.match(/\/api_gateway_mc_proxy\/api\/hal\/\d*\/block\d*/) ||
      url.match(/\/api_gateway_mc_proxy\/api\/users\/\d*\/counter/) ||
      url.match(/\/contacts\/stream-channel-id/) ||
      url.match(/\/trades/) ||
      url.match(/\/trades\/[a-z0-9-]+\/init/) ||
      url.match(/\/trade-service\/accept-terms/) ||
      url.match(/\/v2\/users\/[0-9]+\/alerts\/[a-z0-9-]+\/title/) ||
      url.match(/\/v2\/users\/[0-9]+\/alerts$/) ||
      url.match(/\/users\/[0-9]+\/alerts\/[a-z0-9-]+/) ||
      url.match(/\/users\/[0-9]+\/ads\/[a-z0-9-]+\/fields\/generate/) ||
      url.match(/\/users\/[0-9]+\/ads\/[A-Z_]+\/id\/$/) ||
      url.match(/\/users\/[0-9]+\/avatar/) ||
      url.match(/\/users\/[0-9]+\/consents/) ||
      url.match(/\/users\/[0-9]+\/password/) ||
      url.match(/\/users\/[0-9]+\/savedsearches\/[a-z0-9-]+/) ||
      url.match(/\/users\/\d*\/matchcounters/) ||
      url.match(/\/users\/\d*\/pending-ad/) ||
      url.match(/\/users\/\d*\/verificationEmail/) ||
      url.match(/\/newsletter\/subscribeAuth/) ||
      url.match(/\/rapidpay/) ||
      url.match(/\/reservations/) ||
      url.match(/\/v1\/reservations/) ||
      url.match(/\/v3\/reservations/) ||
      url.match(/\/ads\/[0-9]+\/reservation-status\?userId=.+$/) ||
      url.match(/\/users\/([^/]+)\/messagingToken/) ||
      url.match(/\/users\/([^/]+)\/messages\/unread-count/) ||
      url.match(/\/v3\/users\/([^/]+)\/alerts\/([^/]+)\/matches/) ||
      url.match(/\/channels\/[^/]+\/(image|file)$/) ||
      url.match(/\/contacts\/stream-channel-context\?channelId=[^&]+/) ||
      url.match(/\/users\/([^/]+)\/blocked/) ||
      url.match(/\/users\/([^/]+)\/unblock\/([^/]+)/) ||
      url.match(/\/contacts\/users\/([^/]+)\/whatsapp-intents/) ||
      url.match(/\/users\/([^/]+)\/renewed-ads\/([^/]+)/) ||
      url.match(/\/users\/\d+\/ads\/\d+$/) ||
      url.match(/\/users\/\d+\/ads\/?$/) ||
      url.match(/\/users\/\d+\/free-ads-available/) ||
      url.match(/\/vehicle\/[^/]+\/car-specs/) ||
      url.match(/\/ads\/[^/]+\/detail\/phone/) ||
      url.match(/\/users\/\d+\/instant-offers\/draft/)
    ) {
      return this._authenticationFetcher
    }

    if (alwaysSendAuthorizationToken === true && isUserLogged === true) {
      return this._authenticationFetcher
    }

    return this._httpFetcher
  }
}
